(() => {
  const day = 86400000;
  const key = d => d.toISOString().slice(0, 10);
  const add = (d, n) => new Date(d.getTime() + n * day);
  const easter = y => {
    const a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),v=h+l-7*m+114;
    return new Date(Date.UTC(y,Math.floor(v/31)-1,v%31+1));
  };
  const holidayCache = new Map();
  const holidays = (year, country) => {
    const cacheKey=year+country;
    if(holidayCache.has(cacheKey))return holidayCache.get(cacheKey);
    const e=easter(year);
    const fixed={PL:['01-01','01-06','05-01','05-03','08-15','11-01','11-11','12-24','12-25','12-26'],FR:['01-01','05-01','05-08','07-14','08-15','11-01','11-11','12-25'],DE:['01-01','05-01','10-03','12-25','12-26'],BE:['01-01','05-01','07-21','08-15','11-01','11-11','12-25'],CZ:['01-01','05-01','05-08','07-05','07-06','09-28','10-28','11-17','12-24','12-25','12-26'],HU:['01-01','03-15','05-01','08-20','10-23','11-01','12-25','12-26'],SK:['01-01','01-06','05-01','07-05','08-29','11-01','12-24','12-25','12-26']};
    const movable={PL:[1,60],FR:[1,39,50],DE:[-2,1,39,50],BE:[1,39,50],CZ:[-2,1],HU:[-2,1,50],SK:[-2,1]};
    const extra=country==='HU'&&year===2026?['01-02','08-21','12-24']:[];
    const result=new Set([...(fixed[country]||[]).concat(extra).map(s=>year+'-'+s),...(movable[country]||[]).map(n=>key(add(e,n)))]);
    holidayCache.set(cacheKey,result);
    return result;
  };
  const business = (d, country='PL') => d.getUTCDay()!==0 && d.getUTCDay()!==6 && !holidays(d.getUTCFullYear(),country).has(key(d));
  const addBusiness = (d,n,country='PL') => {
    let result=new Date(d);
    while(n>0){result=add(result,1);if(business(result,'PL')&&business(result,country))n--;}
    return result;
  };
  const warsawFormatter=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Warsaw',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
  const warsawParts=date=>Object.fromEntries(warsawFormatter.formatToParts(date).filter(p=>p.type!=='literal').map(p=>[p.type,p.value]));
  const cutoffInstant=(date,hour)=>{
    const wallTime=date.getTime()+hour*3600000;
    const parts=warsawParts(new Date(wallTime));
    const localTime=Date.UTC(+parts.year,+parts.month-1,+parts.day,+parts.hour,+parts.minute,+parts.second);
    return new Date(wallTime-(localTime-wallTime));
  };
  const estimate = (now, handling, country, cutoff=13) => {
    const parts=warsawParts(now);
    const today=new Date(Date.UTC(+parts.year,+parts.month-1,+parts.day));
    const seconds=+parts.hour*3600+ +parts.minute*60+ +parts.second;
    const open=business(today)&&seconds<cutoff*3600;
    let intake=today;
    if(!open){intake=add(intake,1);while(!business(intake))intake=add(intake,1);}
    const ship=Number.isInteger(handling)&&handling>=0?addBusiness(intake,handling):null;
    const transit={PL:[1,1],FR:[2,3],DE:[2,3],BE:[2,3],CZ:[2,3],HU:[2,3],SK:[2,3]}[country];
    const standardArrival=ship&&transit?transit.map(n=>addBusiness(ship,n,country)):null;
    const expressTransit={FR:[1,2],DE:[1,2],BE:[1,2],CZ:[1,2],HU:[1,2],SK:[1,2]}[country];
    const expressArrival=ship&&expressTransit?expressTransit.map(n=>addBusiness(ship,n,country)):null;
    const arrival=standardArrival&&expressArrival
      ? [expressArrival[0]<standardArrival[0]?expressArrival[0]:standardArrival[0],expressArrival[1]>standardArrival[1]?expressArrival[1]:standardArrival[1]]
      : standardArrival;
    const deadline=cutoffInstant(intake,cutoff);
    return {open,minutes:Math.max(1,Math.ceil((deadline-now)/60000)),deadline,intake,ship,arrival,standardArrival,expressArrival};
  };
  if(typeof module!=='undefined'&&module.exports)module.exports={estimate,business,addBusiness,key};
  if(typeof window==='undefined'||!window.customElements)return;
  class AvDeliveryEstimate extends HTMLElement {
    connectedCallback(){this.update();this.timer=setInterval(()=>this.update(),30000);}
    disconnectedCallback(){clearInterval(this.timer);}
    update(){
      const data=this.dataset;
      const handling=data.handling?.trim()?Number(data.handling):-1;
      const state=estimate(new Date(),handling,data.country,Number(data.cutoff)||13);
      const locale=data.locale||'en';
      const format=d=>new Intl.DateTimeFormat(locale,{day:'numeric',month:'short',weekday:'short',timeZone:'UTC'}).format(d);
      const replace=(s,v)=>s.replace('__VALUE__',v);
      const title=this.querySelector('[data-av-delivery-title]');
      const note=this.querySelector('[data-av-delivery-note]');
      if(state.arrival){
        const value=key(state.arrival[0])===key(state.arrival[1])?format(state.arrival[0]):format(state.arrival[0])+' – '+format(state.arrival[1]);
        title.textContent=replace(data.arrival,value);
      }else if(state.ship){title.textContent=replace(data.dispatch,format(state.ship));}
      else {title.textContent=data.cutoffLabel;}
      if(state.ship&&data.countdownEnabled!=='false'){
        const days=Math.floor(state.minutes/1440),hours=Math.floor(state.minutes%1440/60),minutes=state.minutes%60;
        const unit=(n,u)=>new Intl.NumberFormat(locale,{style:'unit',unit:u,unitDisplay:'short'}).format(n);
        const duration=[days?unit(days,'day'):'',hours?unit(hours,'hour'):'',unit(minutes,'minute')].filter(Boolean).join(' ');
        note.textContent=replace(data.countdown,duration);
        note.hidden=false;
      }else{note.textContent='';note.hidden=true;}
      this.hidden=false;
    }
  }
  if(!customElements.get('av-delivery-estimate'))customElements.define('av-delivery-estimate',AvDeliveryEstimate);
})();
